import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100% !important",
    paddingTop: "5px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "black",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.background.default,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.background.default,
    },
  },
}));

export default function AutoCompleteComponent<T extends object>({
  dropdownItems,
  propertyName,
  label,
  onChange,
  selectOption,
  currValue,
  id = null,
}: {
  dropdownItems: T[];
  propertyName: string;
  label: string;
  onChange: (event: React.ChangeEvent<unknown>, value: T | null) => void;
  selectOption?: (option: T, value: T) => boolean;
  currValue?: T | null;
  id?: string | null;
}) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Autocomplete
      value={currValue}
      className={classes.root}
      options={dropdownItems}
      getOptionLabel={(option) => (option as Record<string, string>)[propertyName]}
      getOptionSelected={selectOption}
      style={{ width: 300 }}
      onChange={onChange}
      id={id ?? undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputLabelProps={{ style: { color: theme.palette.primary.main } }}
        />
      )}
    />
  );
}
